import React, { useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import { AlertBox, Icons, Button } from 'msp-components'
import { useCommerceSFRAAPI, useAccountOrders } from 'msp-integrations'
import { OrderActionProps } from '@/pages/account/AccountOrders/AccountOrderDetail/OrderActions/OrderActions.types'
import translations from './OrderCancellationAction.constants'
import * as S from './OrderCancellationAction.styles'

const OrderCancellationAction = ({
  order,
  isProcessing,
  setIsProcessing = () => {},
  setIsCancelled = () => {},
  setAlertBoxMessage = () => {},
  setIsError = () => {}
}: OrderActionProps) => {
  const { formatMessage } = useIntl()
  const { fetchOrder } = useAccountOrders()
  const confirmBoxRef = useRef<AlertBox>()
  const SFRAClient = useCommerceSFRAAPI()
  const confirmAction = async () => {
    const payload = {
      orderNo: order.orderNo,
      description: 'Order cancelled by customer'
    }
    const alertMessageSuccess = {
      type: 'success',
      message: formatMessage(translations.orderCancellationSuccess)
    }
    const alertMessageError = {
      type: 'error',
      message: formatMessage(translations.orderCancellationError)
    }

    setIsProcessing(true)
    confirmBoxRef?.current.closeAlert()

    try {
      const res = await SFRAClient.Order.cancelOrder({ body: payload })

      if (!res.error) {
        fetchOrder(order.orderNo, true)
        setAlertBoxMessage(alertMessageSuccess)
      } else {
        throw new Error()
      }
    } catch (error) {
      setAlertBoxMessage(alertMessageError)
      setIsError(true)
    } finally {
      setIsProcessing(false)
      setIsCancelled(true)
    }
  }

  return (
    <>
      <Button
        className={S.ActionButton}
        variant='danger'
        type='secondary'
        isDisabled={isProcessing}
        onClick={() => confirmBoxRef?.current?.showAlert()}
      >
        {formatMessage(translations.cancelOrder)}
      </Button>
      <AlertBox
        ref={confirmBoxRef}
        type='standard'
        headlineColor={S.ConfirmationHeadline}
        title={formatMessage(translations.orderCancellationTitle)}
        closeButtonIcon={<Icons iconName='Close' size='base' />}
      >
        <div
          className={`${S.ConfirmationDescription} ${S.ConfirmationHeadline}`}
        >
          {formatMessage(translations.orderCancellationDescription)}
        </div>

        <div className={S.ConfirmationButtonsWrapper}>
          <Button
            type={'secondary'}
            variant='outline'
            className={S.ConfirmationCancelButton}
            onClick={() => confirmBoxRef?.current?.closeAlert()}
          >
            {formatMessage(translations.orderCancellationCancel)}
          </Button>
          <Button type='secondary' onClick={confirmAction}>
            {formatMessage(translations.orderCancellationConfirm)}
          </Button>
        </div>
      </AlertBox>
    </>
  )
}

export default OrderCancellationAction
